var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDownArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 6,
    viewBox: "0 0 12 6",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Down 2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M11 5L9.25269 3.23703C7.85925 1.8311 7.16253 1.12813 6.31333 1.01989C6.10527 0.99337 5.89473 0.99337 5.68667 1.01989C4.83748 1.12813 4.14075 1.8311 2.74731 3.23703L1 5",
    stroke: "#181038",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownArrow);
export default __webpack_public_path__ + "static/media/down-arrow.3b260c66945337bef3d3dd6082d6469e.svg";
export { ForwardRef as ReactComponent };